export const PAGE_CONFIG = {
  "name": "CommonPermissionWrap",
  "children": [
    {
      "name": "CommonLogWrap",
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "902701",
          "pageName": "studioAssessment",
          "extInfo": "home-studio-studioAssessment",
          "pagePath": "/studioAssessment"
        }
      },
      "children": [
        {
          "name": "StudioAssessmentFilter",
          "data": {
            "subtitle": "-"
          },
          "props": {
            "system": "studio",
            "api": "/api/v2/dashboard/studio/assessment/select",
            "subtitle": "Last Updated : {{subtitle}}",
            "subtitleCn": "最近更新 : {{subtitle}}",
            "tipEn": "The first place in the filter will directly affect the sorting and detailed description in the radar chart, dimension, and overall comparison overview. Please make sure that the correct Studio is prioritized.",
            "tipCn": "筛选器中排序首位会直接影响雷达图、维度大类、总体对比表现宽表中的排序和详情描述，请确认已将正确的Studio排至首位。",
            "checkBoxConfig": {
              "value": [],
              "checkList": [
                {
                  "value": "height",
                  "key": "benchmark_high",
                  "name": "Benchmark-High",
                  "nameEn": "Benchmark-High",
                  "nameCn": "行业基准-好"
                },
                {
                  "value": "mid",
                  "key": "benchmark_mid",
                  "name": "Benchmark-Mid",
                  "nameEn": "Benchmark-Mid",
                  "nameCn": "行业基准-中"
                },
                {
                  "value": "low",
                  "key": "benchmark_low",
                  "name": "Benchmark-Low",
                  "nameEn": "Benchmark-Low",
                  "nameCn": "行业基准-差"
                }
              ]
            }
          },
          "children": [
            {
              "name": "StudioAssessmentCommonService",
              "props": {
                "api": "/api/v2/dashboard/studio/assessment/performance"
              },
              "children": [
                {
                  "name": "StudioAssessmentCommonService",
                  "props": {
                    "api": "/api/v2/dashboard/studio/assessment/class/risk_level",
                    "dataKey": "riskLevel",
                    "extraParams": {
                      "isRiskLevelInterface": "true"
                    }
                  },
                  "children": [
                    {
                      "name": "StudioAssessmentBenchmark",
                      "props": {
                        "benchmarkConfig": [
                          {
                            "benchmark_level": "benchmark_high",
                            "value": "10",
                            "benchmark_level_description_en": "There are currently no technical risks that affect players' actual gaming experience",
                            "benchmark_level_description_cn": "当前不存在影响玩家实际游戏体验的技术风险"
                          },
                          {
                            "benchmark_level": "benchmark_mid",
                            "value": "6",
                            "benchmark_level_description_en": "Small number of technical risks affecting players' experience, but there are solid mitigation plans to minimize the impact",
                            "benchmark_level_description_cn": "存在少量影响玩家游戏体验的技术风险，但应对措施和优化方案能保障不会危害绝大部分玩家利益"
                          },
                          {
                            "benchmark_level": "benchmark_low",
                            "value": "3",
                            "benchmark_level_description_en": "There are several technical risks, and players' experience will be severely degraded despite mitigation measures",
                            "benchmark_level_description_cn": "存在严重影响玩家游戏体验的技术风险，且应对措施不能完全消除风险"
                          }
                        ]
                      },
                      "children": [
                        {
                          "name": "StudioAssessmentRadarChart",
                          "props": {
                            "style": {
                              "marginTop": "20px"
                            },
                            "showTitle": false,
                            "checkColorMap": {
                              "benchmark_high": "#F4F6FF",
                              "benchmark_mid": "#E6EAFF",
                              "benchmark_low": "#D9E0FF"
                            },
                            "checkColorMapDark": {
                              "benchmark_high": "#F4F6FF",
                              "benchmark_mid": "#E6EAFF",
                              "benchmark_low": "#D9E0FF"
                            },
                            "showRiskLevel": true,
                            "dimensionColorMap": {
                              "c1": "#1FD2E6",
                              "c2": "#ED95E0",
                              "c3": "#395CFF"
                            }
                          }
                        },
                        {
                          "name": "StudioAssessnebtTableCard",
                          "props": {
                            "style": {
                              "marginTop": "20px"
                            },
                            "titleEn": "Comparison Overview",
                            "titleCn": "总体对比表现",
                            "colorLists": {
                              "light": [
                                "#C63F53",
                                "#F58FA2",
                                "#29C182"
                              ],
                              "dark": [
                                "#9F3044",
                                "#BC5D6B",
                                "#64B691"
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
